export default "/assets/images/handshake.png?84f99abf3ce8fde9ade7540059970fdc";